export default __webpack_public_path__ + "static/media/NoirPro-Regular.ab8b0034.otf";